import { apiInstance } from "@/shared/api/base"
import type { WordPressFeedResponse } from "@/shared/types/wordpress"

export async function getFeed(queryString?: string): Promise<WordPressFeedResponse> {
	const qs = queryString?.startsWith("?") ? queryString : queryString ? `?${queryString}` : ""
	return apiInstance.get<WordPressFeedResponse>(`/api/feed${qs}`)
}

export async function getFeedCount(queryString: string): Promise<number> {
	const response = await getFeed(queryString)
	return response.count
}
